// Yezur-flavored overpass-turbo config.
//
// Copied over upstream's js/configs.ts by scripts/build-overpass-turbo.sh
// before the vite build runs. Touches all the user-visible defaults:
//   - Overpass API endpoint (our Caddy-proxied local instance)
//   - Default basemap (our carto Standard Mapnik — the site's default — not osm.org's)
//   - Default map view (Yezur's center, matching the homepage and viewer)
//   - localStorage namespace (kept distinct so any other open
//     overpass-turbo.eu tab doesn't share saved-query state with us)
//   - osmAuth (effectively disabled — there's no public OSM to sync to)
//
// If you bump the upstream pin and configs.ts grows new fields, port them
// here too.

export default {
  appname: "overpass-turbo (Yezur)",
  settingNamespace: "overpass-ide-yezur",

  // Same-origin: served behind our single Caddy front door, so no CORS
  // surprises. Root-relative path routes through Caddy's reverse_proxy →
  // wiktorn/overpass-api container in the compose network. Host-agnostic:
  // resolves against whatever origin the SPA loaded from, so localhost:8080
  // and the public domain both work with no rebuild.
  defaultServer: "/overpass/api/",
  suggestedServers: [
    "/overpass/api/"
  ],

  // Default basemap = Standard (osm-carto Mapnik via Caddy's /carto/ route) —
  // the same default as the site's Leaflet layer switcher (layers.yml entry 1).
  // OSM's tile.openstreetmap.org would show Earth — useless backdrop for
  // viewing Yezur features. The Bright raster (tileserver-gl) stays available
  // as a suggested alternative. NOTE: osm-carto is an optional service — when
  // it's down these tiles 502 (same graceful failure as the site's Standard
  // layer); switch to the Bright entry in that case.
  defaultTiles: "/carto/tile/{z}/{x}/{y}.png",
  tileServerAttribution: `© <a href="/copyright">Wib / Yezur</a>`,
  suggestedTiles: [
    "/carto/tile/{z}/{x}/{y}.png",
    "/raster/styles/yezur/{z}/{x}/{y}.png"
  ],

  // Match the homepage default (settings.local.yml + patches/001-default-map-center.patch).
  defaultMapView: {
    lat: 46.7427,
    lon: -85.6491,
    zoom: 5
  },
  // Carto (the default above) renders natively to z20 (layers.yml maxZoom).
  // The Bright alternative's pmtiles emit to z14 and over-zoom past that —
  // scaled-up but usable, same behaviour as iD's background.
  maxMapZoom: 20,

  short_url_service: "",
  push_history_url: true,
  html2canvas_use_proxy: false,

  // Disable the osmnames geocoder. When the search-shim lands (D-014
  // follow-ups), we'll point this at it so place-name search works in
  // the FFS ("From a Forward Search") query builder.
  osmnamesApiKey: "",

  // Disable osm-auth — there's no public OSM to sign in against, and
  // the "saved queries" sync feature isn't useful for a solo instance.
  // url left empty (host-agnostic); never dereferenced since client_id is "".
  osmAuth: {
    url: "",
    client_id: ""
  }
};
